/* eslint-disable react/prop-types */
import { getHistoricosPermisos } from 'api/nominas/historicoPermisos';
import { checkToken } from 'api/utils';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import { formatReceived } from 'utils/formatValues';
import { getModelPermission } from 'utils/permission';

export const HistoricoPermisoPermission = {
  permissionModel: 'historicopermiso',
  catalogsModels: [],
  tabsModels: [],
};

const ExpedientePermisos = ({
  currentEmpleado,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPermission = getModelPermission(
    HistoricoPermisoPermission.permissionModel,
    HistoricoPermisoPermission.catalogsModels,
    HistoricoPermisoPermission.tabsModels,
    false,
  );

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
      ] = await Promise.all([
        getHistoricosPermisos({ empleado: currentEmpleado, es_un_permiso: true }),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const columns = [
    {
      titleText: 'Fecha Ejecución',
      dataIndex: 'fecha_de_ejecucion',
      key: 'fecha_de_ejecucion',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Fecha Inicial de Permiso',
      dataIndex: 'fecha_de_inicio',
      key: 'fecha_de_inicio',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Fecha Final de Permiso',
      dataIndex: 'fecha_de_fin',
      key: 'fecha_de_fin',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Días de Permiso',
      dataIndex: 'dias_de_permiso',
      key: 'dias_de_permiso',
      width: 200,
    },
    {
      titleText: 'Ausentismo Referencia',
      dataIndex: 'ausentismo_referencia',
      key: 'ausentismo_referencia',
      width: 200,
    },
    {
      titleText: 'Motivo de Permiso',
      dataIndex: 'motivo_permiso',
      key: 'motivo_permiso',
      width: 200,
    },
    {
      titleText: 'Goce de Sueldo',
      dataIndex: 'goce_de_sueldo',
      key: 'goce_de_sueldo',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
  ];
  return (
    <Table
      cols={columns}
      data={data}
      permission={getPermission}
      loading={loading}
      allowExportPDF={false}
    />
  );
};

export default ExpedientePermisos;
